module.exports = __webpack_public_path__ + "img/drug55.410aff3f.png";